function getCsrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
}

export async function fetchWithCsrf(url, options = {}) {
  const csrf = getCsrfToken()

  const headers = {
    'Content-Type': 'application/json',
    ...(csrf && { 'X-CSRF-Token': csrf }),
    ...options.headers
  }

  const response = await fetch(url, {
    ...options,
    headers
  })

  return response
}

export async function postJson(url, body = {}) {
  const response = await fetchWithCsrf(url, {
    method: 'POST',
    body: JSON.stringify(body)
  })

  return response.json()
}

